import { createApiCall2, MethodType, URI } from "../Api";
import { ForgotPasswordData } from "models/forgotPassword";

export const fetchForgotPassword = (payload: ForgotPasswordData) => {
  return createApiCall2(MethodType.PUT, URI.AUTH.FORGOTPASSWORD, payload);
};
